import { render, staticRenderFns } from "./InspectionName.vue?vue&type=template&id=dc6d0dc0"
import script from "./InspectionName.vue?vue&type=script&lang=js"
export * from "./InspectionName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports